"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREMIUM_PLUS_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT = exports.PREMIUM_PLUS_SUBSCRIPTION_YEARLY_PRICE = exports.PREMIUM_PLUS_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT = exports.PREMIUM_PLUS_SUBSCRIPTION_MONTHLY_PRICE = void 0;
exports.PREMIUM_PLUS_SUBSCRIPTION_MONTHLY_PRICE = '346 Kč';
exports.PREMIUM_PLUS_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT = '419 Kč';
exports.PREMIUM_PLUS_SUBSCRIPTION_YEARLY_PRICE = '3 463 Kč';
exports.PREMIUM_PLUS_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT = '4 190 Kč';
//# sourceMappingURL=premium-plus-subscription.js.map